import React from "react";
import { Container } from "react-bootstrap";
import './Footer.css'
const Footer = () =>{
   
    let url="https://leadconcept.com/";
    return(
        <>
    
       <div className="footer">
            <p>© 2022 Blacksheep. All Rights Reserved</p>
            <p>Designed & Developed by <a href={url} target={"_blank"} >LEADconcept</a></p>
        </div>
      
        </>
    )
}
export default Footer;
